<div [formGroup]="userForm">
  <div formArrayName="applications">
    <div class="d-flex align-items-baseline">
      <label class="form-label">
        {{ 'admin.userForm.labels.applications' | translate }}
      </label>

      <button class="btn btn-outline-primary btn-icon btn-sm ms-4"
        type="button"
        (click)="addApplicationEntry()"
        [disabled]="availableApplications.length == 0"
        [ngbTooltip]="'admin.userForm.labels.newApp' | translate"
        placement="right"
        >
        <i class="fa-regular fa-plus fa-lg"></i>
      </button>
    </div>

    @for (appForm of applications.controls; track appForm; let i = $index; let last = $last) {
      <div
        class="pt-3" [ngClass]="{'pb-3 border-bottom': !last}">
        <app-user-app-entry [inputId]="i"
          [appForm]="appForm"
          [availableApplications]="availableApplications"
          (appRemoved)="removeApplicationEntry(i)"
          [selectedApplications]="selectedApplications"
          >
        </app-user-app-entry>
      </div>
    }

  </div>
</div>